import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import AddUpdateAgendaCard from "../Card/AddUpdateAgendaCard";
import { useSelector } from "react-redux";


function AddUpdateAgendaDialog({ onClose, open }) {
    const currentAgenda = useSelector((state) => state.meeting.currentAgenda);
    const isUpdate = Boolean(
        currentAgenda && !Array.isArray(currentAgenda) && currentAgenda.id
    );
    return (
        <Dialog
            onClose={onClose}
            open={open}
            fullWidth
            maxWidth="lg"
            keepMounted={false}
        >
            <DialogTitle>{isUpdate ? 'Gündem Güncelle' : 'Gündem Ekle'}</DialogTitle>
            <DialogContent dividers>
                {open && (
                    <AddUpdateAgendaCard
                        key={isUpdate ? currentAgenda.id : 'new-agenda'}
                        onClose={onClose}
                    />
                )}
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
}

export default AddUpdateAgendaDialog